var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C29.5 0 33.75 1 37.5 3.25C41.25 5.5 44.25 8.5 46.5 12.25C48.75 16 50 20.5 50 25C50 29.5 49 33.75 46.75 37.5C44.5 41.25 41.5 44.25 37.75 46.5C34 48.75 29.5 50 25 50C20.5 50 16.25 49 12.5 46.75C8.75 44.5 5.5 41.25 3.25 37.5C1 33.75 0 29.5 0 25C0 20.5 1 16.25 3.25 12.5C5.5 8.75 8.75 5.5 12.5 3.25C16.25 1 20.5 0 25 0ZM25 43.75C29 43.75 32.5 42.5 35.75 40.25L9.75 14.25C7.5 17.5 6.25 21 6.25 25C6.25 28.5 7 31.5 8.75 34.5C10.5 37.5 12.75 39.75 15.5 41.25C18.5 43 21.5 43.75 25 43.75ZM25 6.25C21 6.25 17.5 7.5 14.25 9.75L40.25 35.75C42.5 32.5 43.75 29 43.75 25C43.75 21.5 43 18.5 41.25 15.5C39.5 12.75 37.25 10.25 34.5 8.75C31.75 7.25 28.5 6.25 25 6.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibited);
export default __webpack_public_path__ + "static/media/prohibited.4ff4b88435bdb1563d70adad04691938.svg";
export { ForwardRef as ReactComponent };